import { useState } from 'react'
import Link from 'next/link'
import Icon from '@components/shared/Icon'
import useT from '@hooks/useTranslation'
import withUser from '@hoc/withUser'

import COLORS from '@constants/values/pdfColors'

const BASE = '/api/offers'

const Pdf = ({ offer: { _user, type, _id: adId } = {}, isLoggedIn, user }) => {
    const { _id } = user || {}
    const userId = _user?._id || _user
    const isOwner = _id === userId
    if (!isLoggedIn || !isOwner) return null

    const [isOpen, setIsOpen] = useState(false)
    const open = () => setIsOpen(!isOpen)
    const urlPart = `${type}/${adId}`
    return (
        <>
            <button className="bt" style={{ padding: 6 }} onClick={open}>
                <Icon>picture_as_pdf</Icon> {useT('Drukuj')}
            </button>

            {
                isOpen && <div style={{ display: 'flex', margin: '6px 0' }}>
                    { COLORS.map(color => <Color {...{ key: color, color, urlPart }} />) }
                </div>
            }
        </>
    )
}

function Color ({ color, urlPart }) {
    return (
        <Link href={`${BASE}/${urlPart}/pdf/${color.slice(1)}`}>
            <a target="_blank" rel="noopener noreferrer">
                <div style={{ background: color, height: 30, marginRight: 6, width: 30, }}></div>
            </a>
        </Link>
    )
}

export default withUser(Pdf)